export default __webpack_public_path__ + "static/media/logo-app-store-ios.7b01bef1.svg";